import React,{useState, useEffect} from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight, Wallet, Search } from "lucide-react";

import crown from "../../assets/img/crown.svg";
import userimg from "../../assets/img/user-img.png";
import dollar from "../../assets/img/dollar.svg";
import fire from "../../assets/img/fire.svg";
import CoinBar from "./CoinBar";
import TopContributors from "./TopContributors";
import TrendingSurveys from "./TrendingSurveys";
import SidebarFooter from "./SidebarFooter";

const sidefooterlink = [
  { label: "About Company", to: "/about" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Cookie Preferences", to: "/cookie-policy" },
  // { label: "Data Protection & Security", to: "/" },
 
];

const searches = [
    "remote work productivity",
    "hybrid team survey 2025",
    "async communication tools",
    "employee engagement SaaS",
];



const DashboardRightSidebar = () => {

  const location = useLocation();
  const isSearchResultsPage = location.pathname === "/search-results";

  const [isLoggedIn, setIsLoggedIn] = useState(false);
    
  useEffect(() => {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("user")
    ) {
      setIsLoggedIn(true);
    }
  }, []);





  return (
    <div className="col-xl-3 col-md-12 col-12 rightsidebar d-block">
      
      <div className="row row-cols-1 row-cols-sm-1 row-cols-md-3 row-cols-lg-4 row-cols-xl-1 g-3 w-100">

        {isLoggedIn ? (
            <>              

             {isSearchResultsPage ? (
              <div className="col d-flex">
                <div className="coin-card position-relative overflow-hidden w-100 h-100 mb-0">         
                    <h2 className="fw-bold mb-3">Survey access unlocked</h2>        
                    <p className="coin-desc">You can now view eligibility, participant data, researcher notes, and earning details.</p>
                    <button className="buy-btn w-100 fw-bold">Browse unlocked surveys</button>
                </div>
              </div>
             ):(
              <>
                <CoinBar />
                <TopContributors />              
                <TrendingSurveys />
              </>
             )
            }

            </>

          ) : (

            <>
              <div className="col d-flex">
                <div className="coin-card position-relative overflow-hidden w-100 h-100 mb-0"> 
        
                    {/* <h2 className="fw-bold mb-3">{unlocktitle}</h2>   */}
                    <h2 className="fw-bold mb-3">Unlock full survey access</h2>  

                    {/* Unlock full survey access */}
        
                    <p className="coin-desc">
                        Sign in to see eligibility, participant data, deadlines, researcher notes, and earning details.
                    </p>
        
                    <button className="buy-btn w-100 fw-bold">Sign Up</button>
        
                    <p className="wallet-history ft-13 text-center fw-bold mt-4">No account?  
                      <Link to="/" className="">
                        <span> Join for free</span> 
                    </Link></p>
                </div>
              </div>  
              
            </>
            
          )
        }


        {/* Start Suggested Searches */}

        {isSearchResultsPage && (
          <div className="col d-flex">
            <div className="right-card w-100 h-100 mb-0">
                <h4 className="fw-bold ft-16 mb-4">
                    Suggested Searches
                </h4>

                <div className="suggested-search-list ft-13 fw-bold d-flex flex-column gap-3">

                  {searches.map((item, index) => (
                      <div key={index} className="suggested-search-item d-flex align-items-center gap-3 py-3 px-3 rounded-4">
                          <Search size={20} />
                          <span>{item}</span>
                      </div>
                  ))}                 

                    {/* <div className="suggested-search-item d-flex align-items-center gap-2 py-3 px-3 rounded-4">
                        <Search size={20} />
                        <span style={{ color: "#4F4A52" }}>employee engagement SaaS</span>
                    </div> */}

                </div>
            </div>
          </div>
        )}
        
        

        {/* <div className="col d-flex">
            <div className="right-card w-100 h-100 mb-0">
            <h4 className="fw-bold mb-4">Quick Insights</h4>
            <div className="d-flex align-items-center gap-3 quickbox">
                <div className="iconbtn">
                <img src={dollar} alt="dollar" />
                </div>
                <div>
                <div className="quickname">Weekly Earned</div>

                <small className="quickno">120 Coins</small>
                </div>
            </div>
            <div className="d-flex align-items-center gap-3 quickbox">
                <div className="iconbtn">
                <img src={fire} alt="fire" />
                </div>

                <div>
                <div className="quickname">Weekly Earned</div>

                <small className="quickno">120 Coins</small>
                </div>
            </div>
            </div>
        </div> */}

        <SidebarFooter/>


      </div>
    </div>
  );
};

export default DashboardRightSidebar;
